import type { VFC } from 'react'

import noop from 'shared/utils/noop'
import Body from 'views/components/organisms/CmsMobileMenu/Body'
import NavigationHeader from 'views/components/organisms/CmsMobileMenu/NavigationHeader'
import type { CmsCanvasViewProps } from 'views/components/organisms/CmsMobileMenu/types'
import OffcanvasLogoutItem from 'views/components/organisms/OffCanvas/OffCanvasLogoutItem'

const CmsCanvasView: VFC<CmsCanvasViewProps> = ({
  categoryData,
  closeMenuHandler,
  goNextHandler,
  userData,
}) => (
  <div
    aria-labelledby="OffCanvasViewHeader"
    className="o-OffCanvasView o-OffCanvasView--entry"
    data-clientside-hook="menu"
  >
    <NavigationHeader closeMenuHandler={closeMenuHandler} userData={userData} />

    <Body
      categoryData={categoryData}
      goNextHandler={goNextHandler}
      isTopLevel
      userLoggedIn={userData?.isLoggedIn}
    />

    {userData?.isLoggedIn && <OffcanvasLogoutItem />}
  </div>
)

CmsCanvasView.defaultProps = {
  closeMenuHandler: noop,
  goNextHandler: noop,
}

export default CmsCanvasView
